import AdminLoadable from 'components/core/AdminLoadable';

export default AdminLoadable({
  loader: () => import('./EarningsDashboard'),
  name: 'EarningsDashboard',
});
